/**
 * Verschiebt den Quotify „Angebot anfragen“-Button in die Zeile neben Stückzahl und Warenkorb.
 * App-Blöcke können nicht per Snippet neu gerendert werden – daher DOM-Verschiebung.
 */
function moveQuotifyButton(root = document) {
  root.querySelectorAll('.thb-product-detail').forEach((productDetail) => {
    const row = productDetail.querySelector('.product-quantity-cart-row');
    const quotifyBlock = productDetail.querySelector('[id*="quotify_button"].shopify-app-block');

    if (!row || !quotifyBlock || row.contains(quotifyBlock)) {
      return;
    }

    const quantity = row.querySelector('.quantity');
    const addToCart = row.querySelector('.single-add-to-cart-button');

    if (quantity) {
      quantity.insertAdjacentElement('afterend', quotifyBlock);
    } else if (addToCart) {
      row.insertBefore(quotifyBlock, addToCart);
    } else {
      row.appendChild(quotifyBlock);
    }
  });
}

function updateQuotifyVisibility(root = document) {
  root.querySelectorAll('.product-quantity-cart-row > .shopify-app-block[id*="quotify_button"]').forEach((block) => {
    const hasButton = block.querySelector('.quotify-request-quote-btn, button, a.button');
    block.classList.toggle('is-visible', !!hasButton);
  });
}

const QUOTIFY_REQUEST_SELECTOR = [
  '.thb-product-detail [id*="quotify_button"] .quotify-request-quote-btn',
  '.thb-product-detail [id*="quotify_button"] quotify-button button',
  '.thb-product-detail [id*="quotify_button"] quotify-button a'
].join(', ');

/**
 * Bei Angebotsprodukten blendet Quotify oben den Warenkorb-Button aus. Die Sticky-Leiste
 * darf dann nicht „In den Warenkorb“ anbieten, sonst landet das Produkt im echten
 * Warenkorb und der Preis wird im Checkout sichtbar. Stattdessen tritt dort der
 * „Angebot anfragen“-Button an seine Stelle.
 */
function updateStickyQuoteButton(root = document) {
  const sticky = root.querySelector('product-add-to-cart-sticky');

  if (!sticky) {
    return;
  }

  const quoteButton = sticky.querySelector('[data-quotify-sticky-request]');
  const cartButton = sticky.querySelector('#AddToCartSticky');
  const mainCartButton = document.querySelector('.thb-product-detail #AddToCart');

  if (!quoteButton || !mainCartButton) {
    return;
  }

  const cartHiddenAbove = window.getComputedStyle(mainCartButton).display === 'none';
  const useQuote = cartHiddenAbove && !!document.querySelector(QUOTIFY_REQUEST_SELECTOR);

  quoteButton.hidden = !useQuote;

  if (cartButton) {
    cartButton.hidden = useQuote;
  }
}

function initQuotifyLayout(root = document) {
  moveQuotifyButton(root);
  updateQuotifyVisibility(root);
  updateStickyQuoteButton(root);

  [300, 800, 1500, 3000, 5000].forEach((delay) => {
    window.setTimeout(() => {
      moveQuotifyButton(root);
      updateQuotifyVisibility(root);
      updateStickyQuoteButton(root);
    }, delay);
  });
}

function observeQuotify(root = document) {
  root.querySelectorAll('.thb-product-detail [id*="quotify_button"] quotify-button, .thb-product-detail [id*="quotify_button"]').forEach((target) => {
    if (target.dataset.quotifyLayoutObserved) {
      return;
    }

    target.dataset.quotifyLayoutObserved = '1';

    const observer = new MutationObserver(() => {
      moveQuotifyButton(root);
      updateQuotifyVisibility(root);
      updateStickyQuoteButton(root);
    });

    observer.observe(target, { childList: true, subtree: true });
  });
}

/**
 * Der Sticky-Button ist nur ein Stellvertreter: geklickt wird der echte App-Button
 * oben im Formular. Fehlt er (noch), wird stattdessen dorthin gescrollt.
 */
function handleStickyQuoteClick(event) {
  const trigger = event.target.closest && event.target.closest('[data-quotify-sticky-request]');

  if (!trigger) {
    return;
  }

  event.preventDefault();

  const requestButton = document.querySelector(QUOTIFY_REQUEST_SELECTOR);

  if (requestButton) {
    requestButton.click();
    return;
  }

  const quotifyBlock = document.querySelector('.thb-product-detail [id*="quotify_button"]');

  if (quotifyBlock) {
    quotifyBlock.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  initQuotifyLayout();
  observeQuotify();
});

/**
 * Rueckmeldung auf den Klick.
 *
 * Zwischen Tippen und sichtbarem Angebotsfenster liegen gemessen 0,5 bis 1,0
 * Sekunden, in Ausreissern deutlich mehr: Quotify holt den Inhalt erst nach
 * dem Klick von quotify.dev und baut ihn dann als Iframe auf. In dieser Zeit
 * passiert am Knopf nichts — auf dem Telefon liest sich das wie "hat nicht
 * reagiert", und es wird ein zweites Mal getippt.
 *
 * Die Wartezeit selbst gehoert der App und laesst sich von hier nicht
 * verkuerzen. Sichtbar machen laesst sie sich schon: der Knopf geht sofort in
 * einen Ladezustand und nimmt in dieser Zeit keine weiteren Klicks an.
 */
const QUOTIFY_LADE_KLASSE = 'quotify-laedt';
const QUOTIFY_FENSTER_SELECTOR = 'iframe[src*="quotify.dev"]';
let quotifyLadeWache = null;
let quotifyLadeTimer = null;

function quotifyLadenBeenden() {
  document.querySelectorAll('.' + QUOTIFY_LADE_KLASSE).forEach((knopf) => {
    knopf.classList.remove(QUOTIFY_LADE_KLASSE);
    knopf.removeAttribute('aria-busy');
  });

  if (quotifyLadeWache) {
    quotifyLadeWache.disconnect();
    quotifyLadeWache = null;
  }
  window.clearTimeout(quotifyLadeTimer);
}

function quotifyLadenAnzeigen(knopf) {
  if (!knopf || knopf.classList.contains(QUOTIFY_LADE_KLASSE)) {
    return false;
  }

  knopf.classList.add(QUOTIFY_LADE_KLASSE);
  knopf.setAttribute('aria-busy', 'true');

  // Fertig, sobald das Fenster der App im Dokument steht.
  quotifyLadeWache = new MutationObserver(() => {
    if (document.querySelector(QUOTIFY_FENSTER_SELECTOR)) {
      quotifyLadenBeenden();
    }
  });
  quotifyLadeWache.observe(document.body, { childList: true, subtree: true });

  // Notbremse, falls das Fenster nie kommt. Dann steht der Knopf wieder
  // bereit, statt dauerhaft im Ladezustand zu haengen.
  quotifyLadeTimer = window.setTimeout(quotifyLadenBeenden, 12000);
  return true;
}

document.addEventListener('click', (event) => {
  const ziel = event.target.closest && event.target.closest(
    '[data-quotify-sticky-request], .quotify-request-quote-btn'
  );

  if (!ziel) {
    return;
  }

  // Zweiter Klick waehrend des Ladens bleibt wirkungslos.
  if (ziel.classList.contains(QUOTIFY_LADE_KLASSE)) {
    event.preventDefault();
    event.stopPropagation();
    return;
  }

  if (document.querySelector(QUOTIFY_FENSTER_SELECTOR)) {
    return;
  }

  quotifyLadenAnzeigen(ziel);
}, true);

document.addEventListener('click', handleStickyQuoteClick);

document.addEventListener('shopify:section:load', (event) => {
  initQuotifyLayout(event.target);
  observeQuotify(event.target);
});
